import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "safe-area" }
const _hoisted_2 = { class: "pages-container" }
const _hoisted_3 = {
  key: 0,
  class: "bottom-nav"
}
const _hoisted_4 = { class: "nav-icon-wrap" }
const _hoisted_5 = { class: "nav-icon-wrap" }
const _hoisted_6 = { class: "nav-icon-wrap" }
const _hoisted_7 = {
  key: 0,
  class: "nav-promo"
}
const _hoisted_8 = { class: "nav-icon-wrap" }

import { onMounted, onUnmounted, ref, watch, computed, nextTick } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { initTelegram, requestFullscreen, getSafeAreaInsets, isMobileDevice } from './utils/telegram';
import { haptic } from './utils/telegram';

const REFERRAL_DOT_KEY = 'referralNavDotSeen';
const REFERRAL_BONUS = 250; // сумма в ярлыке над иконкой

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

_useCssVars(_ctx => ({
  "57d3bcf7": (safeArea.value.top.value + safeArea.value.top.unit),
  "6e599fe0": (safeArea.value.right?.value + (safeArea.value.right?.unit ?? "px")),
  "5c726e2c": (safeArea.value.bottom?.value + (safeArea.value.bottom?.unit ?? "px")),
  "4d735674": (safeArea.value.left?.value + (safeArea.value.left?.unit ?? "px"))
}))

const router = useRouter();
const route = useRoute();
const transitionName = ref('slide-left');

const safeArea = ref(getSafeAreaInsets({
  top: { value: isMobileDevice() ? 12 : 0, unit: 'vh' },
}));

// Определяем порядок страниц в навигации
const pageOrder: Record<string, number> = {
  '/': 0,
  '/buyVPN': 1,
  '/referal': 2,
  '/profile': 3,
  '/deposit': 10,
  '/tasks': 10,
  '/ChooseOSView': 10,
  '/payment-history': 10,
};

// Страницы где показывать bottom-nav (основные страницы)
const pagesWithNav = ['/', '/buyVPN', '/referal', '/profile'];

let previousPageIndex = 0;

const currentRoute = computed(() => route.path);

// Индекс активной вкладки для скользящей пилюли
const navIndexMap: Record<string, number> = {
  '/': 0,
  '/buyVPN': 1,
  '/referal': 2,
  '/profile': 3,
};
const navIndex = computed(() => navIndexMap[route.path] ?? 0);

// Показывать bottom-nav только на основных страницах
const showBottomNav = computed(() => {
  return pagesWithNav.includes(route.path);
});

/* ============================================
   ✅ ТОЧКА УВЕДОМЛЕНИЯ НА «РЕФЕРАЛ»
   Показывается, пока пользователь не открыл раздел.
   Флаг живёт в localStorage — точка не вернётся.
   ============================================ */
const showReferralDot = ref(false);

const dismissReferralDot = () => {
  if (!showReferralDot.value) return;
  showReferralDot.value = false;
  try { localStorage.setItem(REFERRAL_DOT_KEY, 'true'); } catch (e) { /* noop */ }
};

// ✅ Одноразовое более заметное покачивание при нажатии (перезапускается каждый раз)
const referralTapWiggle = ref(false);
let referralTapTimer: ReturnType<typeof setTimeout> | null = null;

const playReferralWiggle = async () => {
  if (referralTapTimer) clearTimeout(referralTapTimer);
  referralTapWiggle.value = false;
  await nextTick();
  referralTapWiggle.value = true;
  referralTapTimer = setTimeout(() => { referralTapWiggle.value = false; }, 620);
};

watch(
  () => route.path,
  (newPath, oldPath) => {
    // ✅ Зашёл в раздел — точка пропадает
    if (newPath === '/referal') dismissReferralDot();

    const newIndex = pageOrder[newPath] ?? -1;
    const oldIndex = pageOrder[oldPath] ?? previousPageIndex;

    // Определяем направление анимации
    if (newIndex >= 10 && oldIndex < 10) {
      // Открытие модальной страницы
      transitionName.value = 'slide-up';
    } else if (oldIndex >= 10 && newIndex < 10) {
      // Закрытие модальной страницы
      transitionName.value = 'slide-down';
    } else if (newIndex > oldIndex) {
      // Переход вперед
      transitionName.value = 'slide-left';
    } else if (newIndex < oldIndex) {
      // Переход назад
      transitionName.value = 'slide-right';
    } else {
      // Неопределенный переход
      transitionName.value = 'fade';
    }

    previousPageIndex = newIndex !== -1 ? newIndex : oldIndex;
  },
  { immediate: true }
);

// ✅ Одноразовые анимации остальных иконок: дверь домика, едущая тележка, приподнятая голова
const tapped = ref<string | null>(null);
let tapTimer: ReturnType<typeof setTimeout> | null = null;

const playTap = async (name: string) => {
  if (tapTimer) clearTimeout(tapTimer);
  tapped.value = null;
  await nextTick();
  tapped.value = name;
  tapTimer = setTimeout(() => { tapped.value = null; }, 950);
};

const goTo = (route: string) => {
  haptic.impact();
  if (route === 'referal') {
    dismissReferralDot();
    playReferralWiggle(); // ✅ покачивание в ответ на нажатие
  } else {
    playTap(route === '' ? 'home' : route === 'buyVPN' ? 'buy' : 'profile');
  }
  router.push(`/${route}`);
};

// ✅ ИСПРАВЛЕНО: Асинхронная инициализация с обработкой ошибок
onMounted(async () => {
  // ✅ Точка уведомления: показываем, если раздел ещё не открывали
  try {
    showReferralDot.value = localStorage.getItem(REFERRAL_DOT_KEY) !== 'true' && route.path !== '/referal';
    if (route.path === '/referal') dismissReferralDot();
  } catch (e) {
    showReferralDot.value = true;
  }

  try {
    console.log('🚀 Starting Telegram initialization...');

    // Ждём загрузки и инициализации Telegram SDK
    await initTelegram();

    // После успешной инициализации запрашиваем fullscreen
    requestFullscreen();

    console.log('✅ App.vue: Telegram initialized successfully');
  } catch (error) {
    console.error('❌ App.vue: Failed to initialize Telegram:', error);

    // Можно показать fallback UI или уведомление пользователю
    // alert('Не удалось инициализировать Telegram WebApp. Пожалуйста, откройте приложение через Telegram.');
  }
});
onUnmounted(() => {
  if (referralTapTimer) clearTimeout(referralTapTimer);
  if (tapTimer) clearTimeout(tapTimer);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component, route }) => [
          _createVNode(_Transition, {
            name: transitionName.value,
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: route.path
              }))
            ]),
            _: 2
          }, 1032, ["name"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, { name: "nav-slide" }, {
      default: _withCtx(() => [
        (showBottomNav.value)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
              _createElementVNode("div", {
                class: "nav-pill",
                style: _normalizeStyle({ transform: `translateX(calc(100% * ${navIndex.value}))` })
              }, null, 4),
              _createElementVNode("button", {
                class: _normalizeClass(["nav-item", { active: currentRoute.value === '/' }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (goTo('')))
              }, [
                _createElementVNode("span", _hoisted_4, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["nav-icon", { anim: tapped.value === 'home' }])
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("svg", {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none"
                    }, [
                      _createElementVNode("path", {
                        d: "M4 11l8-7 8 7v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z",
                        stroke: "currentColor",
                        "stroke-width": "1.9",
                        "stroke-linejoin": "round"
                      }),
                      _createElementVNode("path", {
                        class: "door",
                        d: "M9.4 20v-6.2h5.2V20",
                        stroke: "currentColor",
                        "stroke-width": "1.9",
                        "stroke-linejoin": "round"
                      })
                    ], -1)
                  ]), 2)
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "nav-label" }, "Главная", -1))
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["nav-item", { active: currentRoute.value === '/buyVPN' }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (goTo('buyVPN')))
              }, [
                _createElementVNode("span", _hoisted_5, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["nav-icon", { anim: tapped.value === 'buy' }])
                  }, _cache[6] || (_cache[6] = [
                    _createElementVNode("svg", {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none"
                    }, [
                      _createElementVNode("g", { class: "cart" }, [
                        _createElementVNode("path", {
                          d: "M3 4h2l2.4 12.5a1 1 0 0 0 1 .8h8.7a1 1 0 0 0 1-.8L20.5 8H6",
                          stroke: "currentColor",
                          "stroke-width": "1.9",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("circle", {
                          cx: "9",
                          cy: "20",
                          r: "1.4",
                          fill: "currentColor"
                        }),
                        _createElementVNode("circle", {
                          cx: "17",
                          cy: "20",
                          r: "1.4",
                          fill: "currentColor"
                        })
                      ])
                    ], -1)
                  ]), 2)
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "nav-label" }, "Купить", -1))
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["nav-item", { active: currentRoute.value === '/referal' }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (goTo('referal')))
              }, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_Transition, { name: "dot-pop" }, {
                    default: _withCtx(() => [
                      (showReferralDot.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, "+" + _toDisplayString(REFERRAL_BONUS) + " ₽"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", {
                    class: _normalizeClass(["nav-icon wiggle", { tap: referralTapWiggle.value }])
                  }, _cache[8] || (_cache[8] = [
                    _createElementVNode("svg", {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none"
                    }, [
                      _createElementVNode("rect", {
                        x: "3",
                        y: "8",
                        width: "18",
                        height: "13",
                        rx: "2",
                        stroke: "currentColor",
                        "stroke-width": "1.9"
                      }),
                      _createElementVNode("path", {
                        d: "M3 12h18M12 8v13",
                        stroke: "currentColor",
                        "stroke-width": "1.9"
                      }),
                      _createElementVNode("path", {
                        d: "M12 8s-1-4-4-4-3 3 0 4M12 8s1-4 4-4 3 3 0 4",
                        stroke: "currentColor",
                        "stroke-width": "1.9",
                        "stroke-linecap": "round"
                      })
                    ], -1)
                  ]), 2)
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "nav-label" }, "Реферал", -1))
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["nav-item", { active: currentRoute.value === '/profile' }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (goTo('profile')))
              }, [
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["nav-icon", { anim: tapped.value === 'profile' }])
                  }, _cache[10] || (_cache[10] = [
                    _createElementVNode("svg", {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none"
                    }, [
                      _createElementVNode("circle", {
                        class: "head",
                        cx: "12",
                        cy: "8",
                        r: "4",
                        stroke: "currentColor",
                        "stroke-width": "1.9"
                      }),
                      _createElementVNode("path", {
                        class: "body",
                        d: "M4 20c0-3.6 3.6-6 8-6s8 2.4 8 6",
                        stroke: "currentColor",
                        "stroke-width": "1.9",
                        "stroke-linecap": "round"
                      })
                    ], -1)
                  ]), 2)
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "nav-label" }, "Профиль", -1))
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})